import HeaderMessageCreation from "../../../../components/HeaderMessageCreation/HeaderMessageCreation";
// import Seo from '@/components/Seo/Seo'
import UserWrapper from "../../../../layout/userwrapper/UserWrapper";
import {
    Box,
    Button,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../../styles/pages/user/content-buyer-purchaserequest.module.scss";
import { Link } from "react-router-dom";
// import Image from 'next/image'
import assest from "../../../../json/assest";
import PrevIcon from "../../../../ui/Icons/PrevIcon";
import NextIcon from "../../../../ui/Icons/NextIcon";
import useFetch from "../../../../hooks/api/useFetch";
import {
    getMonthQueryRange,
    getPagination,
    getUtcDate,
    getUtcTime,
} from "../../../../lib/functions/utils.lib";
import ApiLoader from "../../../../components/Loaders/ApiLoader";

const PurchaseRequest = () => {
    const [status, setStatus] = React.useState("");
    const [month, setMonth] = React.useState("");
    const [year, setYear] = React.useState("");
    const [archive, setArchive] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [filters, setFilters] = useState(null);

    const handleStatusChange = (event) => {
        setStatus(event.target.value);
    };

    const handleMonthChange = (event) => {
        setMonth(event.target.value);
    };

    const handleYearChange = (event) => {
        setYear(event.target.value);
    };

    const handleArchiveToggle = () => {
        setArchive((prev) => !prev);
    };

    const applyFilters = () => {
        setFilters({ status: status, month: month, year: year });
    };

    const resetFilters = () => {
        setStatus("");
        setMonth("");
        setYear("");
        setFilters(null);
    };

    const {
        data: buyerPurchaseRequests,
        isLoading: buyerPurchaseRequestsIsLoading,
        isSuccess: buyerPurchaseRequestsIsSuccess,
    } = useFetch(
        ["buyer-purchase-requests", filters, archive, currentPage],
        `buyer/purchase/requests?page=${currentPage}${
            filters?.status.toString()
                ? `&${
                      filters?.status == 2
                          ? "need_your_reply=yes"
                          : "status=" + filters?.status
                  }`
                : ""
        }
    &archive=${archive ? 1 : 0}
    ${
        filters?.month && filters?.year
            ? `&from=${
                  getMonthQueryRange(filters?.month, filters?.year, "obj")
                      .from_date
              }&to=${
                  getMonthQueryRange(filters?.month, filters?.year, "obj")
                      .to_date
              }`
            : ""
    }`
    );

    const [paginationData, setPaginationData] = useState({
        hasNextPage: false,
        hasPrevPage: false,
    });
    useEffect(() => {
        const { hasNextPage, hasPrevPage } = getPagination(
            buyerPurchaseRequests?.data?.meta?.current_page,
            buyerPurchaseRequests?.data?.meta?.last_page
        );
        setPaginationData({
            hasNextPage: hasNextPage,
            hasPrevPage: hasPrevPage,
        });
    }, [buyerPurchaseRequests]);

    const handleNextPage = () => {
        if (paginationData.hasNextPage) setCurrentPage((prev) => prev + 1);
    };
    const handlePrevPage = () => {
        if (paginationData.hasPrevPage) setCurrentPage((prev) => prev - 1);
    };
    return (
        <UserWrapper headerPurchaseBtn={false} footerChatBtn={true}>
            <ApiLoader
                loading={
                    buyerPurchaseRequestsIsLoading &&
                    !(
                        filters?.status.toString() ||
                        filters?.month ||
                        filters?.year
                    )
                }
            />
            {/* ====================================================== */}
            {/* =========== WHEN NO PURCHASE REQUEST START =========== */}
            {/* ====================================================== */}

            {/*  */}

            {/* ====================================================== */}
            {/* ============ WHEN NO PURCHASE REQUEST END ============ */}
            {/* ====================================================== */}
            {buyerPurchaseRequestsIsLoading &&
            !(filters?.status.toString() || filters?.month || filters?.year) ? (
                ""
            ) : (buyerPurchaseRequestsIsSuccess &&
                  buyerPurchaseRequests?.data.data.length) ||
              filters?.status.toString() ||
              filters?.month ||
              filters?.year ||
              archive ? (
                <Paper elevation={0} className="pageInnerWrapper">
                    <HeaderMessageCreation
                        status={status}
                        month={month}
                        year={year}
                        handleStatusChange={handleStatusChange}
                        handleMonthChange={handleMonthChange}
                        handleYearChange={handleYearChange}
                        handleArchiveToggle={handleArchiveToggle}
                        filters={filters}
                        resetFilters={resetFilters}
                        applyFilters={applyFilters}
                    />
                    <Box className={styles.commonResponsiveTable}>
                        <TableContainer>
                            <Table stickyHeader aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={styles.thPrid}>
                                            PRID
                                        </TableCell>
                                        <TableCell className={styles.thVdourl}>
                                            Video URL
                                        </TableCell>
                                        <TableCell
                                            className={styles.thReqstDate}
                                        >
                                            Request Date
                                        </TableCell>
                                        <TableCell
                                            className={styles.thDecision}
                                        >
                                            Decision
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            className={styles.thPurchased}
                                        >
                                            Purchased?
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            className={styles.thView}
                                        >
                                            View
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {buyerPurchaseRequests?.data?.data?.map(
                                        (item, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell
                                                        className={
                                                            styles.thPrid
                                                        }
                                                    >
                                                        #{item?.id}
                                                    </TableCell>
                                                    <TableCell
                                                        className={
                                                            styles.thVdourl
                                                        }
                                                    >
                                                        <Link
                                                            to={item?.video_url}
                                                            target="blank"
                                                        >
                                                            {item?.video_url
                                                                ? item?.video_url
                                                                : "-"}
                                                        </Link>
                                                    </TableCell>
                                                    <TableCell
                                                        className={
                                                            styles.thReqstDate
                                                        }
                                                    >
                                                        {getUtcDate(
                                                            item?.created
                                                        )}
                                                        <br />
                                                        {getUtcTime(
                                                            item?.created
                                                        )}
                                                    </TableCell>
                                                    <TableCell
                                                        className={
                                                            styles.thDecision
                                                        }
                                                    >
                                                        <span
                                                            className={
                                                                item?.status ===
                                                                0
                                                                    ? `${styles.warningStatus} ${styles.decisionStatus}`
                                                                    : item?.status ===
                                                                      1
                                                                    ? `${styles.successStatus} ${styles.decisionStatus}`
                                                                    : item?.status ===
                                                                      2
                                                                    ? `${styles.dangerStatus} ${styles.decisionStatus}`
                                                                    : ""
                                                            }
                                                        >
                                                            {item?.status === 1
                                                                ? "Approved"
                                                                : item?.status ===
                                                                  2
                                                                ? "Rejected"
                                                                : "Pending"}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        className={
                                                            styles.thPurchased
                                                        }
                                                    >
                                                        <span
                                                            className={
                                                                styles.purchaseStatus
                                                            }
                                                        >
                                                            {item?.status
                                                                ? item?.purchased
                                                                    ? "Yes"
                                                                    : "No"
                                                                : "-"}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        className={
                                                            styles.thView
                                                        }
                                                    >
                                                        <Link href="">
                                                            <img
                                                                src={
                                                                    assest.IconView
                                                                }
                                                                width={16}
                                                                height={16}
                                                                alt="icon"
                                                            />
                                                        </Link>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        }
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {buyerPurchaseRequests?.data?.data.length ||
                        paginationData?.hasNextPage ||
                        paginationData?.hasPrevPage ? (
                            <Stack
                                direction="row"
                                flexWrap="wrap"
                                alignItems="center"
                                className="btnPagination"
                            >
                                <Button
                                    startIcon={<PrevIcon />}
                                    disabled={!paginationData.hasPrevPage}
                                    onClick={handlePrevPage}
                                >
                                    Prev
                                </Button>
                                <Button
                                    endIcon={<NextIcon />}
                                    disabled={!paginationData.hasNextPage}
                                    onClick={handleNextPage}
                                >
                                    Next
                                </Button>
                            </Stack>
                        ) : (
                            ""
                        )}
                    </Box>
                </Paper>
            ) : (
                <Stack className={styles.emptyRequest}>
                    <figure>
                        <img
                            src={assest.purchaseIconLg}
                            width={93}
                            height={89}
                            alt="icon"
                        />
                    </figure>
                    <Typography variant="body1">
                        You haven't made any purchase requests yet.
                    </Typography>
                    <Button>New Purchase Request</Button>
                </Stack>
            )}
        </UserWrapper>
    );
};

export default PurchaseRequest;
